module.exports = __webpack_public_path__ + "static/Micha-Wiebe-4c723a9607852bd33ac6de4f9d87a75b.png";